<div class="input-component">
    <label *ngIf="title" [for]="input.id ? input.id : ''" class="title">{{ title }}: <span class="required" *ngIf="required">*</span></label>
    <!-- Text -->
    <ng-container *ngIf="input.type == 'text' || input.type == 'password' || input.type == 'email'">
      <input [type]="input.type" class="input" 
          [class.text]="!input.size"
          [class.invalid]="invalidState"
          [id]="input.id"
          [name]="name"
          [placeholder]="input.placeholder ? input.placeholder : ''"
          [disabled]="disabled"
          [readonly]="input.readonly"
          [required]="required"

          [size]="input.size ? input.size : '1'"

          [value]="value"
          [attr.minlength]="input.minLength ?? ''"
          [attr.maxlength]="input.maxLength ?? ''"
          (blur)="touched($event)"
      />
    </ng-container>
    <!-- Number -->
    <ng-container *ngIf="input.type == 'number'">
      <input type="number" class="input number"
          [class.invalid]="invalidState"
          [id]="input.id"
          [name]="name"
          [placeholder]="input.placeholder ? input.placeholder : ''"
          [disabled]="disabled"
          [readonly]="input.readonly"
          [required]="required"

          [min]="input.min || ''"
          [max]="input.max || ''"
          [step]="input.step ? input.step : ''"

          [value]="value"
          (blur)="touched($event)"
      />
    </ng-container>
    <!-- Textarea -->
    <ng-container *ngIf="input.type == 'textarea'">
      <textarea class="input textarea"
          [class.invalid]="invalidState"
          [id]="input.id"
          [name]="name"
          [placeholder]="input.placeholder ? input.placeholder : ''"
          [disabled]="disabled"
          [readonly]="input.readonly"
          [required]="required"

          [cols]="input.cols ? input.cols : ''"
          [rows]="input.rows ? input.rows : ''"

          [attr.minlength]="input.minLength ?? ''"
          [attr.maxlength]="input.maxLength ?? ''"
          (blur)="touched($event)"
      >{{ value }}</textarea>
    </ng-container>
</div>